import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/Projects/disciple.png";
import report from "../../Assets/Projects/annual-report.png";
import bitsOfCode from "../../Assets/Projects/st-martha.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Some of My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={report}
              isBlog={false}
              title="Annual Report - Alliance Churches"
              description="I contributed to the development of the Church Advance platform for the Christian & Missionary Alliance (C&MA) in Arkansas. This initiative supports churches in the region by providing resources, coaching, and tools aimed at fostering sustainable growth and advancing the gospel."
              link="https://churchar.cmalliance.org/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="St. Martha’s Hospital"
              description="I developed the official website for St. Martha’s Hospital, a well-known multi-specialty hospital in Bengaluru. The goal was to create a modern, user-friendly platform that helps patients easily find information and services."
              link="https://stmarthas.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Disciple Tools Plugins Development"
              description="I developed two Laravel plugins for the Disciple Tools platform: a Home Screen plugin that provides a customizable dashboard to improve user navigation, and an AutoLink plugin that automatically links related content to help users find information more easily. Both plugins are designed to integrate smoothly with the platform and enhance the overall user experience."
              link="https://www.disciple.tools/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
